import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.PICTURE_THIS;

// Game screens
export const LEVEL_COUNT = 5;

// how many items in each level
export const ITEMS_PER_LEVEL_MAP = [5, 5, 3, 3, 3];

// number of levels with single element for each part
export const SINGLE_PART_LEVELS = 4;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  HOME: 'HOME',
  LOADING: 'LOADING',
  STANDARD: 'STANDARD',
  CARD_PROTOTYPE: 'CARD_PROTOTYPE',
};

export const SCAFFOLD = {
  THRESHOLD: 2,
};

export const ANSWER = {
  UNANSWERED: 'UNANSWERED',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
};

export const ROUND = {
  STORIES_PER_LEVEL: 3,
  MASTERY_THRESHOLD: 2 / 3, // represents 0.666...
};

export const DRAGGABLE_WORD = {
  SNAP_BACK_DURATION: 500,
};

export const STICKER_PANEL = {
  PAYOFF_DELAY: 1000,
  ORIGIN: 0,
  EXIT_TARGET_Y: 450,
  ENTER_START_Y: -450,
  EXIT_DURATION: 350,
  ENTER_DURATION: 600,
  FINAL_PAYOFF_DELAY: 300,
};

export const SCRIPT_PANEL = {
  OFF_PANEL: 500,
  EXIT_PAGE_DURATION: 100,
  ENTER_PAGE_DURATION: 500,
};

export const TUTOR_STATE = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  SPEAKING: 'speaking',
};

export const ACTIONS = {
  // FOR TESTS
  NONE: 'NONE',

  // Interaction
  SET_IS_INTERACTION_LOCKED: 'SET_IS_INTERACTION_LOCKED',

  // VIEW ACTIONS
  CHANGE_SCREEN: 'CHANGE_SCREEN',

  // ON BORDING ACTIONS
  START_ONBOARDING: 'START_ONBOARDING',
  REPLAY_ONBOARDING: 'REPLAY_ONBOARDING',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  END_ONBOARDING: 'END_ONBOARDING',
  SET_NORMAL_VIEW: 'TRIGGER_NORMAL_VIEW',
  SET_IS_SHOWING_HINT: 'SET_IS_SHOWING_HINT',
  SET_IS_ARROW_ANIMATING: 'SET_IS_ARROW_ANIMATING',
  SET_IS_DROPZONE_ANIMATING: 'SET_IS_DROPZONE_ANIMATING',

  // SESSION ACTIONS
  INIT_GAME: 'INIT_GAME',

  // ROUND ACTIONS
  SELECT_LEVEL: 'SELECT_LEVEL',
  START_NEW_ROUND: 'START_NEW_ROUND',
  END_ROUND: 'END_ROUND',
  INCREASE_STORIES_COMPLETE_COUNT: 'INCREASE_STORIES_COMPLETE_COUNT',
  INCREASE_CORRECT_ELEMENT_COUNT: 'INCREASE_CORRECT_ELEMENT_COUNT',
  INCREASE_INCORRECT_ELEMENT_COUNT: 'INCREASE_INCORRECT_ELEMENT_COUNT',
  INCREASE_HELP_COUNTER: 'INCREASE_HELP_COUNTER',
  MASTER_THIS_LEVEL: 'MASTER_THIS_LEVEL',
  QUICK_ROUND: 'QUICK_ROUND',

  UPDATE_SCROLL_PANEL: 'UPDATE_SCROLL_PANEL',
  INCREASE_WRONG_STEP: 'INCREASE_WRONG_STEP',
  TRIGGER_SCAFFOLD: 'TRIGGER_SCAFFOLD',
  FINISH_SCAFFOLD: 'FINISH_SCAFFOLD',

  // ILLUSTRATION PANEL
  START_NEXT_CARD_ANIMATION: 'START_NEXT_CARD_ANIMATION',

  // CONTENT ACTIONS
  CREATE_VIEW_MODEL_FROM_CONTENT: 'CREATE_VIEW_MODEL_FROM_CONTENT',
  NEXT_STORY_ELEMENT: 'NEXT_STORY_ELEMENT',

  // HEADER ACTIONS
  SET_TUTOR_STATE: 'SET_TUTOR_STATE',

  // STANDARD VIEW ACTIONS
  COLLECT_ELEMENT: 'COLLECT_ELEMENT',
  SHOW_PAYOFF: 'SHOW_PAYOFF',
  ADVANCE_CONTENT: 'ADVANCE_CONTENT',
  SET_ELEMENT_AS_USED: 'SET_ELEMENT_AS_USED',

  // METAGAME
  AWARD_ZAPS: 'AWARD_ZAPS',
  AWARD_BITES: 'AWARD_BITES',

  // DRAGGABLE GROUPS ACTIONS
  SET_DRAGGABLE_GROUP_INNACTIVE: 'SET_DRAGGABLE_GROUP_INNACTIVE',
  UPDATE_GROUP_OFFSET: 'UPDATE_GROUP_OFFSET',
  START_GROUP_DRAG: 'START_GROUP_DRAG',
  STOP_GROUP_DRAG: 'STOP_GROUP_DRAG',
  SHAKE_DROPZONE: 'SHAKE_DROPZONE',
  GROUP_GOT_HOME: 'GROUP_GOT_HOME',

  // SCRIPT PANEL
  NEXT_PAGE: 'NEXT_PAGE',
  PREVIOUS_PAGE: 'PREVIOUS_PAGE',

  // DROPZONE
  UPDATE_DROPZONE_LAYOUT: 'UPDATE_DROPZONE_LAYOUT',
  SET_DROPZONE_IS_TOUCHING: 'SET_DROPZONE_IS_TOUCHING',

  // TUTOR
  START_POSITIVE_TUTOR_FEEDBACK: 'START_POSITIVE_TUTOR_FEEDBACK',
  START_TUTOR_ONBOARDING: 'START_TUTOR_ONBOARDING',
  START_TUTOR_PROMPT: 'START_TUTOR_PROMPT',
  START_TUTOR_SCAFFOLD_PROMPT: 'START_TUTOR_SCAFFOLD_PROMPT',
  STOP_TUTOR_SEQUENCE: 'STOP_TUTOR_SEQUENCE',
};
